'use strict'

import List from "./list";
import Audio5 from './audio5'

const audio5js = {
    // 初始化
    init,
    // 播放器
    play,
    togPause,
    next,
    prev,
    volume,
    togMuted,
    progress,
    // 界面
    togPlayer,
    togList,
    togLrc,
    // 播放清单
    get,
    add,
    replace,
    remove,
}

let _LIST, _PLAYER;
//let _LRC;

function init(params) {

    // new Audio5()，new List()
    _PLAYER = new Audio5(params);
    _LIST = new List(params);

    _PLAYER.on('ended', () => {
        // 原生loop：true时,ended不能响应，loop:false后，togPause()
        if (_LIST.mode == 'single') {
            togPause();
        } else {
            next();
        }
    })

    _LIST.on('cut', e => {
        // console.log(_LIST.currentIndex);
        // 切歌
        if (e.song.url) {
            _PLAYER.load(e.song.url);
            _PLAYER.togPause();
        }

        // 本地缓存
        // localStorage.setItem('index', JSON.stringify(_LIST.currentIndex));
    })

    // 本地缓存
    // let localList = JSON.parse(localStorage.getItem('list'));
    // let localIndex = JSON.parse(localStorage.getItem('index'));
    // if (localList && localList.length > 0 && localIndex <= localList.length - 1) {
    //     _LIST.list = localList || [];
    //     play(localIndex);
    // }
    // _LIST.on('change', e => {
    //     localStorage.setItem('list', JSON.stringify(e));
    // })
}

function play(index) {
    _LIST.nextTo(index)
}

function togPause() {
    _PLAYER.togPause();
}

function next() {
    _LIST.next();
}

function prev() {
    _LIST.prev();
}

function togMuted() {
    _PLAYER.togMuted();
}

function volume(num) {
    _PLAYER.volume(num)
}

function progress(percent) {
    _PLAYER.seekTo(percent);
}

function togPlayer() {
    _PLAYER.togControls()
}

function togList() {

}

function togLrc() {

}

// ========== 播放清单
function get(index) {
    return _LIST.get(index);
}

function add(data) {
    if (data.url) {
        _LIST.add(data);
    } else {
        if (typeof data === 'string') {
            _LIST.add({
                url: data
            });
        }
    }
}

function replace(fromIndex, toIndex) {
    _LIST.replace(fromIndex, toIndex)
}

function remove(index) {
    if (index) {
        _LIST.del(index);
    } else {
        _LIST.clear();
        _PLAYER.reload();
    }
}

export default audio5js